import { logger } from 'lib/logger';
import { useSelector } from 'react-redux';
import { marchPromo2026, marchPromo2026Anon } from 'reactApp/appHelpers/featuresHelpers/features/marchPromo2026';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import { sendXray } from 'reactApp/utils/ga';
import { captureException } from 'reactApp/utils/tracer';

export const MARCH_PROMO_ENABLED_QUERY_PARAM = 'march-promo-enabled';

export const checkPromoForceQuery = () => {
    try {
        const urlParams = new URLSearchParams(window.location.search);

        return !!urlParams.get(MARCH_PROMO_ENABLED_QUERY_PARAM);
    } catch (error) {
        sendXray('march-promo-2026-failure');
        captureException(error, { issueKey: 'MarchPromo2026: query fetch failure ' });
        logger.error(error);

        return false;
    }
};

export const useMarchPromo2026 = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isOverquota = useSelector(isCloudOrMailOrApiOverQuota);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isAnon = useSelector(UserSelectors.isAnonymous);

    if (isAnon) {
        return marchPromo2026Anon;
    }

    return marchPromo2026 && !isPaidUser && !isOverquota && !isBizUser;
};

export const useMarchPromo2026MailSpace = () => {
    const isMarchPromo = useMarchPromo2026();
    const isQueryForceMarchPromo = checkPromoForceQuery();

    return isMarchPromo || isQueryForceMarchPromo;
};
